import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/do';

@Injectable()
export class AppInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (localStorage.getItem('Token')) {
      let authtoken = localStorage.getItem('Token');
      const clonedRequest = req.clone({ headers: req.headers.set('Authorization', localStorage.getItem('Token')) });
      return next.handle(clonedRequest).do(event => { }, err => {
        if (err instanceof HttpErrorResponse && (err.status == 401)) {
          localStorage.clear();
          this.router.navigate(['login']);
        }
        else if(err instanceof HttpErrorResponse && (err.status == 403)) {
          this.router.navigate(['access-denied'])
        }
      });
    }
    return next.handle(req);
  }
}


// WEBPACK FOOTER //
// ./src/app/app.interceptor.ts